import {
    ShoppingCart,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../Redux/hooks";
import { RootState } from "../../../store";
import "./CheckoutNavbar.css";

const CheckoutNavbar = () => {
    const navigate = useNavigate();
    const { cart } = useAppSelector((state: RootState) => state.customerCart);
    const count = cart?.itemsCount ?? 0;

    return (
        <header className="checkout-navbar">
            <div className="checkout-navbar-inner">
                <div className="checkout-navbar-brand">
                    <Link to="/HomePage" aria-label="Salar Home">
                        <img
                            src="/assets/img/salarlogo.png"
                            alt="Salar"
                            className="checkout-navbar-logo-image"
                        />
                    </Link>
                </div>

                <div className="checkout-navbar-title">
                    <h1> Checkout </h1>
                </div>

                <button
                    type="button"
                    className="checkout-navbar-cart"
                    aria-label="Cart"
                    onClick={() => navigate("/Cart")}
                    title={`Cart (${count} items)`}
                >
                    <ShoppingCart
                        size={19}
                        strokeWidth={1.9}
                    />
                </button>
            </div>
        </header>
    );
};

export default CheckoutNavbar;

